import { trackDashboardCtaClicked } from "analytics";
import { PATHS } from "constants/pathConstants";
import GroupSupportIcon from "assets/images/GroupSupport.svg";
import DashboardCtaCard from ".";
import Translate from "translate/Translate";

const NeedSupportDashboardCtaCard = () => {
  return (
    <DashboardCtaCard
      icon={GroupSupportIcon}
      header={<Translate text={"Need Support"} />}
      subheader={
        <Translate
          text={
            "Our team is here to help answer questions about a cancer diagnosis or your membership."
          }
        />
      }
      link={{
        onClick: () => {
          trackDashboardCtaClicked({
            workflow: "dashboard",
            ctaLocation: "dashboard_card",
            ctaId: "need_support"
          });
        },
        overrideClick: false,
        target: "blank",
        text: "View",
        url: PATHS.RESOURCE_CENTER
      }}
    />
  );
};

export default NeedSupportDashboardCtaCard;
